import React, { useEffect } from 'react';
import { LayoutProps, Notification, useAuthProvider, useRedirect } from 'react-admin';

import { LibroProvider } from '../../../console/data/libro';
import { OverlayProvider } from '../../../console/ui/overlays';
import { ConsoleShell } from '../../../console/shell';
import '../../../console/ui/console.css';

// ─────────────────────────────────────────────────────────────────────────────
// Layout de la consola (fase62). Reemplaza al <Layout> de react-admin —barra
// superior, menú lateral y tab bar móvil— por el chrome del rediseño.
//
// LO QUE SE CONSERVA DEL LAYOUT VIEJO, porque no es decoración:
//   · La GUARDA DE SESIÓN: el mismo `checkAuth` al montar, que exige sesión de
//     Firebase + claim `boMfa` + email de la lista + `isAdmin` en Firestore, y
//     redirige al ingreso si algo falla.
//   · La NOTIFICACIÓN de react-admin: es la que muestran `useNotify` y todos
//     los helpers de escritura (aprobar, guardar APR, purgar…). Sin ella, media
//     consola avisaría en silencio.
//
// Lo que se deja atrás a propósito: el toggle del sidebar (no hay sidebar) y el
// error boundary de react-admin, que se reemplaza por el de abajo — el suyo
// tiraba la app entera al chrome de MUI, y acá alcanza con voltear la pantalla.
// ─────────────────────────────────────────────────────────────────────────────

class Muro extends React.Component<{ children: React.ReactNode }, { err: Error | null }> {
  constructor(props: any) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(err: Error) {
    return { err };
  }

  componentDidCatch(err: Error) {
    // eslint-disable-next-line no-console
    console.error('[consola] la pantalla se cayó', err);
  }

  render() {
    if (!this.state.err) return this.props.children as any;
    return (
      <div style={{ padding: '60px 26px', maxWidth: 620, margin: '0 auto' }}>
        <p className="eyebrow">Algo se rompió</p>
        <h1 className="ptitle" style={{ marginTop: 12 }}>
          Esta pantalla no pudo dibujarse
        </h1>
        <p className="sml" style={{ marginTop: 14, lineHeight: 1.6 }}>
          El resto de la consola sigue funcionando: usá la navegación de arriba para ir a otra
          sección. El detalle técnico está en la consola del navegador.
        </p>
        <p className="mono sml" style={{ marginTop: 18, opacity: 0.7, wordBreak: 'break-word' }}>
          {String(this.state.err?.message ?? this.state.err)}
        </p>
      </div>
    );
  }
}

const AppLayout: React.FC<LayoutProps> = ({ children }) => {
  const authProvider = useAuthProvider();
  const redirect = useRedirect();

  useEffect(() => {
    authProvider.checkAuth({}).catch(() => redirect('/login'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirect]);

  return (
    <LibroProvider>
      <OverlayProvider>
        <ConsoleShell>
          <Muro>{children}</Muro>
        </ConsoleShell>
        <Notification />
      </OverlayProvider>
    </LibroProvider>
  );
};

AppLayout.displayName = 'AppLayout';

export default AppLayout;
